import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8" data-id="element-137">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto bg-gradient-to-br from-pink-50 to-white border border-pink-200 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg" data-id="element-138">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-emerald-50 blur-[80px] pointer-events-none" data-id="element-139" />

        <div className="relative z-10" data-id="element-140">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-emerald-50 mb-6" data-id="element-141">
            <ShieldCheck size={40} className="text-brand-success" data-id="element-142" />
          </div>

          <h2 className="font-display text-3xl md:text-4xl font-bold mb-8 text-gray-900" data-id="element-143">
            GARANTÍA 7 DÍAS
          </h2>

          <div className="space-y-4 text-xl md:text-2xl text-gray-600 font-medium mb-8" data-id="element-144">
            <p data-id="element-145">Probalo.</p>
            <p data-id="element-146">Usalo.</p>
            <p data-id="element-147">
              Si no es para vos:{' '}
              <span className="text-gray-900 font-bold" data-id="element-148">
                👉 devolución del 100%
              </span>
            </p>
          </div>

          <div className="inline-block bg-pink-50 border border-pink-200 rounded-full px-6 py-2 text-gray-500 font-medium" data-id="element-149">
            Sin preguntas. Sin riesgo.
          </div>
        </div>
      </motion.div>
    </section>;
}